import { render, staticRenderFns } from "./ApplicationChoice.vue?vue&type=template&id=8f3f4a96&scoped=true&"
import script from "./ApplicationChoice.vue?vue&type=script&lang=js&"
export * from "./ApplicationChoice.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationChoice.vue?vue&type=style&index=0&id=8f3f4a96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3f4a96",
  null
  
)

export default component.exports